<template>
  <div>
    <b-modal
      id="modalLancement"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="lg"
      :title="titleModal"
    >
      <template #default>
        <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
          <div class="row" v-if="currentEtape">
            <div class="col-md-12">
              <p class="text-center font-weight-bold font-size-17">
                <b>{{
                  currentEtape.libelle
                    ? 'Etape ' +
                      (currentIndex + 1) +
                      ' : ' +
                      currentEtape.libelle
                    : 'Etape ' + (currentIndex + 1)
                }}</b>
              </p>
              <hr />
            </div>
          </div>

          <div class="row d-flex justify-content-center mt-n4">
            <div class="col-md-8 col-lg-6">
              <div class="form-group">
                <label for="date_demarrage"
                  >Date du démarrage <span class="text-danger">*</span></label
                >
                <date-picker
                  v-model="form.date_demarrage"
                  name="date_demarrage"
                  placeholder="Date du démarrage"
                  lang="fr"
                  format="DD/MM/YYYY"
                  value-type="DD/MM/YYYY"
                ></date-picker>
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('date_demarrage'),
                  }"
                  type="hidden"
                />
                <has-error :form="form" field="date_demarrage"></has-error>
              </div>
            </div>
          </div>
        </form>
      </template>
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-danger mr-2"
          @click="$bvModal.hide('modalLancement')"
        >
          Fermer
        </button>

        <button
          type="submit"
          class="btn btn-custom-primary w-40"
          @click="submit"
          style="min-width: 100px"
        >
          Démarrer
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import URL from '@/http/gpao/of-etape';
import Form from 'vform';
import DatePicker from 'vue2-datepicker';

export default {
  data() {
    return {
      form: new Form({
        date_demarrage: this.$options.filters.formatDate(
          new Date(),
          'DD/MM/YYYY'
        ),
        etape: null,
      }),
      titleModal: "Lancement d'une étape",
    };
  },
  components: {
    DatePicker,
  },
  methods: {
    showModal() {
      this.$bvModal.show('modalLancement');
    },
    submit() {
      this.$bvModal.hide('modalLancement');

      this.form.etape = this.currentEtape.uuid;
      this.form
        .post(URL.DEMARRER + '/' + this.currentEtape.id)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);

          this.form.reset();
          this.form.clear();
          this.$emit('onUpdateEtape', resp.data.etape);
        })
        .catch(() => {
          this.$bvModal.show('modalLancement');
        });
    },
  },
  props: ['currentEtape', 'currentIndex'],
};
</script>

<style scoped lang="scss"></style>
